/**
 * List of participating NHS trusts.
 *
 * This constant contains an array of NHS trust organizations that are participating
 * in the system. Each organization has a unique code and display name.
 *
 * @typedef {Object} NHSTrust
 * @property {string} code - The unique identifier for the NHS trust
 * @property {string} name - The display name of the NHS trust
 */
export const PARTICIPATING_NHS_TRUST_LIST = [
  {
    code: '1',
    name: 'Organisation 1',
  },
  {
    code: '2',
    name: 'Organisation 2',
  },
  {
    code: '3',
    name: 'Organisation 3',
  },
  {
    code: '4',
    name: 'Organisation 4',
  },
  {
    code: '5',
    name: 'Organisation 5',
  },
  {
    code: '6',
    name: 'Organisation 6',
  },
  {
    code: '7',
    name: 'Organisation 7',
  },
  {
    code: '8',
    name: 'Organisation 8',
  },
  {
    code: '9',
    name: 'Organisation 9',
  },
  {
    code: '10',
    name: 'Organisation 10',
  },
  {
    code: '11',
    name: 'Organisation 11',
  },
  {
    code: '12',
    name: 'Organisation 12',
  },
  {
    code: '13',
    name: 'Organisation 13',
  },
  {
    code: '14',
    name: 'Organisation 14',
  },
  {
    code: '15',
    name: 'Organisation 15',
  },
  {
    code: '16',
    name: 'Organisation 16',
  },
  {
    code: '17',
    name: 'Organisation 17',
  },
  {
    code: '18',
    name: 'Organisation 18',
  },
  {
    code: '19',
    name: 'Organisation 19',
  },
  {
    code: '20',
    name: 'Organisation 20',
  },
  {
    code: '21',
    name: 'Test Organisation',
  },
];

/**
 * Test Organisation code - used for test data cleanup functionality.
 * This code is hardcoded for safety to prevent accidental deletion of real data.
 */
export const TEST_ORGANISATION_CODE = '21';
